// src/pages/CookiePolicyPage.js
import React from 'react';
import Navbar from '../components/Navbar';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

export default function CookiePolicyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Fix overlay Navbar: spacer sotto la headbar (regola h-20 se la Navbar è più alta/bassa) */}
      <div className="h-20" />

      <div className="container mx-auto px-6 pb-40 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8">Cookie Policy</h1>

        <Card>
          <CardHeader>
            <CardTitle>Informativa sull&apos;utilizzo dei Cookie</CardTitle>
          </CardHeader>

          <CardContent className="prose max-w-none">
            <div className="space-y-8">
              <section>
                <h2 className="text-2xl font-semibold mb-4">1. Premessa</h2>
                <p className="text-gray-700">
                  Il presente sito utilizza esclusivamente <strong>cookie tecnici</strong> e identificativi tecnici strettamente necessari al
                  funzionamento delle pagine, alla gestione dell&apos;area riservata e alla sicurezza del servizio. Il sito <strong>non</strong> utilizza
                  cookie di profilazione, cookie di marketing, né strumenti di tracciamento finalizzati alla profilazione dell&apos;utente.
                </p>
                <p className="text-gray-700">
                  Per tali motivi, ai sensi della normativa vigente, <strong>non è richiesto il consenso</strong> dell&apos;utente e{' '}
                  <strong>non viene visualizzato alcun banner cookie</strong>. Per i cookie tecnici resta ferma l&apos;informativa all&apos;utente.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">2. Cosa sono i cookie?</h2>
                <p className="text-gray-700">
                  I cookie sono piccoli file di testo che vengono memorizzati sul dispositivo dell&apos;utente quando visita un sito web e che possono
                  essere ritrasmessi allo stesso sito alla visita successiva. In questo sito sono utilizzati esclusivamente per finalità tecniche
                  indispensabili (ad esempio sessione, sicurezza e accesso a funzionalità riservate).
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">3. Cookie utilizzati da questo sito</h2>
                <p className="text-gray-700 mb-4">
                  Il presente sito utilizza esclusivamente <strong>cookie tecnici</strong>, necessari al corretto funzionamento delle pagine e a garantire
                  una navigazione sicura ed efficiente.
                </p>

                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <h3 className="font-semibold text-blue-900 mb-2">Cookie Tecnici</h3>
                  <p className="text-sm text-blue-800">
                    I cookie tecnici sono necessari per consentire la navigazione e l&apos;utilizzo delle funzionalità del sito, inclusa l&apos;area riservata
                    con accesso tramite <strong>OTP (One-Time Password)</strong> inviato via e-mail. Possono inoltre essere utilizzati per finalità di sicurezza
                    e prevenzione di abusi. Il sito non utilizza cookie di profilazione o marketing e non impiega strumenti di tracciamento finalizzati alla
                    profilazione dell&apos;utente.
                  </p>
                </div>

                <div className="mt-4">
                  <p className="text-gray-700">
                    In particolare, l&apos;accesso all&apos;area riservata avviene tramite OTP via e-mail, senza utilizzo di password e senza funzionalità
                    &quot;remember me&quot;. Eventuali cookie o token tecnici sono utilizzati esclusivamente per gestire la sessione e l&apos;autenticazione
                    per il tempo necessario all&apos;utilizzo dei servizi.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">4. Tipologie di cookie tecnici utilizzati</h2>
                <ul className="list-disc list-inside space-y-2 text-gray-700">
                  <li>
                    <strong>Cookie di sessione e di funzionamento:</strong> necessari per mantenere la sessione di navigazione e garantire il corretto funzionamento
                    delle pagine, inclusa l&apos;area riservata.
                  </li>
                  <li>
                    <strong>Cookie / token di autenticazione (OTP):</strong> utilizzati per gestire l&apos;autenticazione dell&apos;utente dopo la verifica dell&apos;OTP e
                    consentire l&apos;accesso alle funzionalità riservate, senza memorizzazione persistente del login.
                  </li>
                  <li>
                    <strong>Cookie / identificativi di sicurezza:</strong> utilizzati per finalità di sicurezza e protezione del sito (ad esempio prevenzione abusi,
                    integrità delle richieste e mitigazione di traffico anomalo).
                  </li>
                </ul>

                <p className="text-gray-700 mt-4">
                  <strong>Cloudflare:</strong> il sito utilizza Cloudflare come servizio di sicurezza e ottimizzazione della distribuzione dei contenuti (CDN/WAF).
                  Cloudflare può utilizzare cookie o identificativi tecnici strettamente necessari per protezione da traffico malevolo e attacchi (ad esempio mitigazione
                  DDoS) e per garantire la continuità del servizio.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">5. PostHog (analytics tecnico) e assenza di profilazione</h2>
                <p className="text-gray-700">
                  Il sito può utilizzare <strong>PostHog</strong> per analisi tecnica e miglioramento del servizio (product analytics). L&apos;implementazione è configurata,
                  ove possibile, in modalità <strong>cookieless</strong> e con criteri di minimizzazione, senza finalità di marketing o profilazione. Se in futuro venissero
                  introdotte modalità che richiedono consenso (ad esempio cookie non tecnici o identificativi persistenti per finalità ulteriori), verrà aggiornata la presente
                  informativa e, ove necessario, implementato un meccanismo di consenso.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">6. Durata dei cookie</h2>
                <p className="text-gray-700">
                  I cookie tecnici possono essere <strong>di sessione</strong> (si eliminano alla chiusura del browser o alla scadenza della sessione) oppure, quando strettamente
                  necessario per finalità tecniche e di sicurezza, <strong>persistenti</strong> (memorizzati per un periodo limitato). In ogni caso, non è prevista la memorizzazione
                  del login tramite funzionalità &quot;remember me&quot;.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">7. Gestione dei cookie</h2>
                <p className="text-gray-700 mb-4">
                  Poiché questo sito utilizza solo cookie tecnici strettamente necessari, non è richiesto il consenso dell&apos;utente per il loro utilizzo.
                </p>
                <p className="text-gray-700">
                  È comunque possibile disabilitare i cookie direttamente dalle impostazioni del proprio browser. Si tenga presente che la disabilitazione dei cookie tecnici potrebbe
                  compromettere la corretta navigazione e l&apos;utilizzo di alcune funzionalità del sito, in particolare l&apos;accesso all&apos;area riservata.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">8. Come disabilitare i cookie nel browser</h2>
                <p className="text-gray-700 mb-4">
                  È possibile modificare le impostazioni del browser per bloccare o cancellare i cookie. Di seguito i link alle guide dei principali browser:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700">
                  <li>
                    <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                      Google Chrome
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://support.mozilla.org/it/kb/Attivare%20e%20disattivare%20i%20cookie"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:underline"
                    >
                      Mozilla Firefox
                    </a>
                  </li>
                  <li>
                    <a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                      Safari
                    </a>
                  </li>
                  <li>
                    <a href="https://support.microsoft.com/it-it/microsoft-edge" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                      Microsoft Edge
                    </a>
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">9. Log tecnici e sicurezza (informazione aggiuntiva)</h2>
                <p className="text-gray-700">
                  Per esigenze di sicurezza e funzionamento del servizio, possono essere raccolti <strong>log tecnici</strong> (ad esempio log di accesso e di errore) generati dai
                  sistemi del sito e/o dall&apos;infrastruttura di rete. Tali informazioni sono trattate per finalità tecniche e di sicurezza.
                </p>
                <p className="text-gray-700">
                  Il sito è ospitato in <strong>Italia (Unione Europea)</strong>.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">10. Aggiornamenti</h2>
                <p className="text-gray-700">
                  Questa Cookie Policy può essere aggiornata periodicamente. Si consiglia di consultare regolarmente questa pagina per essere informati su eventuali modifiche.
                </p>
              </section>

              <section className="pt-6 border-t">
                <p className="text-sm text-gray-500">
                  Ultimo aggiornamento: Gennaio 2026 — Contatti: info@acbase.org
                </p>
              </section>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
